<template>
  <div class="inviter-order-list">
    <div class="common-header-wrap">
      <mt-header title="推广业绩" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>
    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
      <div  v-if="orderList && orderList.length" >
        <div class="inviters-item" v-for="(v,k) in orderList" @click="handleToDetail(v)" :key="v.orderinviter_id">
          <div class="item-left">
           <img :src="v.orderinviter_goods_image" alt="">
         </div>
         <div class="item-right" >
           <div class="ellipsi">{{v.orderinviter_goods_name}}</div>
           <p >推广收入: &nbsp;&nbsp;<span class="num">+{{v.orderinviter_money}}</span><img src="../../../assets/image/arrow-left.png"></p>
           <p class="f-s"><span style="color:red;">状态:{{v.orderinviter_order_remark}} </span><span> {{v.orderinviter_addtime}}</span></p>
           <p>订单编号:{{v.orderinviter_order_sn}}</p>
         </div>
        </div>
      </div>
      <empty-record v-else-if="orderList && !orderList.length"></empty-record>
      <!-- <div class="inviters-item">
         <div class="item-left">
           <img src="../../../assets/image/dianzan.png" alt="">
         </div>
         <div class="item-right">
           <div class="ellipsi">百想艺术埃及的dsajis原梓菲萨达萨达萨达萨达大撒大撒</div>
           <p>推广收入: &nbsp;&nbsp;<span class="num">+5</span><img src="../../../assets/image/arrow-left.png"></p>
           <p class="f-s"><span>状态:待结算 </span><span> 2020-01-02</span></p>
           <p>订单编号:213213213213213</p>
         </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { getInviterOrder } from '../../../api/memberInviter'
import EmptyRecord from '../../../components/EmptyRecord'
import { Toast, Indicator } from 'mint-ui'
export default {
  name: 'MemberInviterOrder',
  components: {
    EmptyRecord
  },
  data () {
    return {
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      orderList: false
    }
  },
  created () {

  },

  mounted () {

  },
  methods: {
    handleToDetail(row) {
      this.$router.push({
        name:'MemberInviterDetail',
        query:{
           orderinviter_id:row.orderinviter_id
        }
      })
    },
    getOrderList (ispush) {
      Indicator.open()
      let params = this.params
      getInviterOrder(params).then(res => {
        Indicator.close()
        if (res) {
          if (ispush && this.orderList) {
            this.orderList = this.orderList.concat(res.result.list)
          } else {
            this.orderList = res.result.list
          }
          if (res.result.hasmore) {
            this.isMore = true
          } else {
            this.isMore = false
          }
        }
      })
    },
    loadMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getOrderList(true)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .inviter-order-list {}
  .inviter-order-list .inviter-item {  background-color: #FFF;position: relative; z-index: 1; display: block; padding: 0.5rem 0; border-bottom: solid 0.05rem #EEE;}
  .inviter-order-list .inviter-item .detail { min-height: 1.8rem; margin: 0 5rem 0 0; font-size: 0.55rem; word-wrap:break-word; line-height: 0.9rem; color: #555;padding-left:.5rem}
  .inviter-order-list .inviter-item .money { position: absolute; z-index: 1; top: 0.5rem; right: 0.5rem; height: 0.9rem; line-height: 0.9rem;}
  .inviter-order-list .inviter-item .money.add { color: #f23030;}
  .inviter-order-list .inviter-item .money.reduce { color: #36BC9B;}
  .inviter-order-list .inviter-item .date { position: absolute; z-index: 1; bottom: 0.4rem; right: 0.5rem; height: 0.9rem; font-size: 0.5rem; line-height: 0.9rem; color: #999;}
  .inviter-order-list .inviter-item .date .green{color:green}
  .inviter-order-list .inviter-item .invalid .money.add {color: gray;}
  .inviters-item {
    padding:10px;
    display:flex;
    font-size: 14px;
    box-sizing: border-box;
    background: #fff;
    border-bottom:1px solid #f3f3f3;
    .item-left {
      width:35%;
      height:100px;
      margin-right:10px;
      img {
        width:100%;
        height:100%;
        object-fit: cover;
      }
    }
    .item-right {
      width:65%;
      font-size: 12px;
          display: flex;
    flex-direction: column;
    justify-content: space-between;
      p {
        position: relative;
        line-height: 1;
      }
      .ellipsi {
        overflow: hidden;
       text-overflow: ellipsis;
       display: -webkit-box; /*将对象作为弹性伸缩盒子模型显示。*/
       -webkit-line-clamp: 2; /*设置需要显示的行数*/
       -webkit-box-orient: vertical;
      }
      .num {
        color:red;
        font-size: 16px;
      }
      .f-s {
        display:flex;
        justify-content: space-between;
                line-height: 1;

      }
      img {
        width:14px;
        position: absolute;
        right:0px;
        top:50%;
        transform: translateY(-50%);
      }
    }
  }
</style>
